module.exports = "<div class=\"header-title\">\n    {{title}}\n  </div>"